/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, MenuItem } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CustomOnClickWrapper } from "../../../../components/CustomLink/CustomClickWrapper";
import { StandardTableActions } from "../../../../components/StandardTableActions/StandardTableActions";
import { DataTable } from "../../../../components/Table/DataTable";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../../components/Table/interfaces/IDataTableProps";
import {
  CSVExportPlugin,
  RefreshPlugin,
  SearchPlugin,
} from "../../../../components/Table/plugins";
import { PageContainer } from "../../../../components/container/PageContainer";
import { CustomSelect } from "../../../../components/formsComponents";
import { LoadState, MODULE_IDS } from "../../../../constants/enums";
import { useDispatchWrapper } from "../../../../hooks";

import { IJobContact } from "../../../../redux/job_contacts";
import { clearCustomerBranch } from "../../../../redux/customerBranch";
import {
  ICustomerDeliveryAddress,
  initialCustomerDeliveryAddress,
} from "../../../../redux/customerDeliveryAddress";
import {
  fetchCustomerDispatchAddressListAsync,
  ICustomerDispatchAddress,
  initialCustomerDispatchAddress,
} from "../../../../redux/customerDispatchAddress";
import { IStoreState } from "../../../../redux/initialStoreState";
import { ManageCustomerDispatchAddress } from "./ManageCustomerDispatchAddress";
import { RoleBasedCustomButton } from "../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";

export const CustomerDispatchAddressList: React.FC = () => {
  const { uuid } = useParams() as { uuid?: string };

  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.customerDispatchAddress,
  );

  const { data: customerData } = useSelector(
    (storeState: IStoreState) => storeState.customer.customer,
  );

  const [status, setStatus] = React.useState<IJobContact["status"] | "-1">(
    "-1",
  );
  const [searchColumns, setSearchColumns] = React.useState<string[]>([
    "customer_name",
  ]);
  const [search, setSearch] = React.useState<string>("");
  const [pagination, setPagination] = React.useState<{
    pageNumber: number;
    rowsPerPage: number;
  }>({ pageNumber: 1, rowsPerPage: 10 });

  const dispatch = useDispatchWrapper();

  // ******Right Panel************
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [dialogData, setDialogData] = React.useState<ICustomerDispatchAddress>(
    initialCustomerDispatchAddress,
  );

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setDialogData({
      ...initialCustomerDispatchAddress,
      customer_name: customerData.customer_name,
      customer_uuid: customerData.customer_uuid,
    });
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    dispatch(clearCustomerBranch());
  };
  const handleComplete = () => {
    setOpenDialog(false);
    dispatch(clearCustomerBranch());
    fetchList();
  };

  const contactsTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalRecords,
    rowsPerPageOptions: pagination.rowsPerPage,
    isDataLoading: loading !== LoadState.Loaded,
    selectionMode: "none",
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={status}
                onChange={(e: any) => setStatus(e.target.value as "ACTIVE")}
              >
                <MenuItem value="-1">All Status</MenuItem>
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="INACTIVE">Inactive</MenuItem>
              </CustomSelect>
            ),
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchList} />,
          },
        ],
      },
      rightItems: {
        plugins: {},
        customPlugins: [
          {
            key: "search",
            onRender: () => {
              return (
                <SearchPlugin
                  selectedDropdownValue={searchColumns}
                  dropdownOptions={[
                    { label: "Dispatch Name", value: "dispatch_name" },
                    { label: "Company Name", value: "customer_name" },
                  ]}
                  onDropdownChange={(value) => setSearchColumns(value)}
                  onChange={(newValue) => {
                    setSearch(newValue);
                  }}
                />
              );
            },
          },
        ],
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "customer_name",
        headerName: "Comany Name",
        fieldName: "customer_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
        onRowCellRender: (value, row: ICustomerDispatchAddress) => {
          return (
            <CustomOnClickWrapper
              label={row.customer_name || ""}
              onClick={() => {
                setOpenDialog(true);
                setDialogData(row);
              }}
            />
          );
        },
      },
      {
        key: "dispatch_name",
        headerName: "Dispatch Name",
        fieldName: "dispatch_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "customer_dispatch_address_city",
        headerName: "City",
        fieldName: "customer_dispatch_address_city",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "customer_dispatch_address_state",
        headerName: "State",
        fieldName: "customer_dispatch_address_state",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICustomerDispatchAddress) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                setOpenDialog(true);
                setDialogData(row);
              }}
            />
          );
        },
      },
    ],
    items: list,
    onPageChange: (newPageNumber: number) => {
      setPagination({ ...pagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setPagination({
        pageNumber: pageNumber,
        rowsPerPage: rowsPerPage,
      });
    },
  };

  const fetchList = () => {
    dispatch(
      fetchCustomerDispatchAddressListAsync(
        {
          status: status,
          page: pagination.pageNumber,
          rowsPerPage: pagination.rowsPerPage,
          columns: searchColumns,
          value: search,
        },
        uuid,
      ),
    );
  };

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, status, search]);

  return (
    <PageContainer title="" description="">
      <Box
        display={"flex"}
        justifyContent={"end"}
        sx={{
          mx: 5,
          my: 2,
        }}
      >
        {/* <Button
					variant="contained"
					onClick={() => handleOpenDialog()}
				>
					Add New
				</Button> */}
        <RoleBasedCustomButton
          moduleId={MODULE_IDS.COMPANY_DISPATCH_ADDRESS}
          variant="contained"
          onClick={() => handleOpenDialog()}
        >
          Add Dispatch Address
        </RoleBasedCustomButton>
      </Box>
      <DataTable {...contactsTableProps} />
      {openDialog && (
        <ManageCustomerDispatchAddress
          open={openDialog}
          data={dialogData}
          onClose={() => handleCloseDialog()}
          onComplete={() => handleComplete()}
        />
      )}
    </PageContainer>
  );
};
